// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2nTRn","errorLogs":"EditorFooter_errorLogs__3zLKo"};